export const TOGGLE_BOXED_LAYOUT = "TOGGLE_BOXED_LAYOUT";
export const TOGGLE_COLLAPSED_NAV = "TOGGLE_COLLAPSED_NAV";
export const TOGGLE_NAV_BEHIND = "TOGGLE_NAV_BEHIND";
export const TOGGLE_FIXED_HEADER = "TOGGLE_FIXED_HEADER";
export const CHANGE_SIDEBAR_WIDTH = "CHANGE_SIDEBAR_WIDTH";
export const CHANGE_COLOR_OPTION = "CHANGE_COLOR_OPTION";
export const CHANGE_THEME = "CHANGE_THEME";
export const AUTH_LOGIN = "AUTH_LOGIN";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const CLEAR_CONTEXT = "CLEAR_CONTEXT";
export const SET_HAS_MULTIPLE_GROUP_COMPANIES =
  "SET_HAS_MULTIPLE_GROUP_COMPANIES";
export const SET_GROUP_COMPANY_ID = "SET_GROUP_COMPANY_ID";
export const START_PROCESSING = "START_PROCESSING";
export const STOP_PROCESSING = "STOP_PROCESSING";
export const SET_GROUP_COMPANY_NAME = "SET_GROUP_COMPANY_NAME";
export const SET_SUBSIDIARY_ID = "SET_SUBSIDIARY_ID";

